import { Reveal } from "./Reveal";
import { HIGHLIGHTS, STATS } from "../data/content";

export default function Results() {
    return (
        <section
            id="rezultate"
            data-testid="results"
            className="px-6 py-32 md:px-12 md:py-48"
        >
            <div className="mx-auto max-w-6xl">
                <Reveal>
                    <span className="eyebrow">Rezultate</span>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2
                        className="mt-6 font-serif font-light leading-[0.94]"
                        style={{ fontSize: "clamp(3rem, 9vw, 8rem)" }}
                    >
                        Rezultatele vorbesc
                    </h2>
                </Reveal>

                {/* Highlights — quiet, editorial, no icons, no colour blocks */}
                <div className="mt-16 flex flex-wrap items-center gap-x-3 gap-y-4 md:mt-24">
                    {HIGHLIGHTS.map((h, i) => (
                        <Reveal key={h} delay={0.06 * i}>
                            <span className="flex items-center">
                                <span
                                    className="font-serif font-light"
                                    style={{
                                        fontSize: "clamp(1.5rem, 3.6vw, 2.8rem)",
                                    }}
                                >
                                    {h}
                                </span>
                                {i < HIGHLIGHTS.length - 1 && (
                                    <span
                                        className="mx-5 md:mx-8"
                                        style={{
                                            color: "var(--accent)",
                                            fontSize: "1.1rem",
                                        }}
                                    >
                                        ·
                                    </span>
                                )}
                            </span>
                        </Reveal>
                    ))}
                </div>

                {/* Stats — hairline dividers, big serif numerals */}
                <div className="mt-20 grid grid-cols-1 gap-px sm:grid-cols-3 md:mt-32">
                    {STATS.map((s, i) => (
                        <Reveal key={s.label} delay={0.1 * i}>
                            <div
                                className="border-t pt-7"
                                style={{ borderColor: "var(--ink)" }}
                                data-testid={`stat-${i}`}
                            >
                                <div className="flex items-baseline">
                                    <span
                                        className="font-serif font-light leading-none"
                                        style={{
                                            fontSize: "clamp(3.4rem, 6vw, 5.5rem)",
                                        }}
                                    >
                                        {s.value}
                                    </span>
                                    <span
                                        className="font-serif font-light"
                                        style={{
                                            color: "var(--accent)",
                                            fontSize: "clamp(2rem, 3vw, 2.6rem)",
                                        }}
                                    >
                                        {s.suffix}
                                    </span>
                                </div>
                                <p className="eyebrow eyebrow-ink mt-5">
                                    {s.label}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
